import { QRCodeCanvas } from "qrcode.react";
import { useState } from "react";
import { useToast } from "./NeonToast";
import NeonToast from "./NeonToast";
const KPay = ({
  title,
  timeLeft,
  MSG,
  lang,
  qrPayload,
  qrRef,
  amount,
  merchantOrderId,
  orderId,
}) => {
  const { toast, show, hide } = useToast("");

  function isAndroidApkInAppWebView() {
    const ua = navigator.userAgent || "";

    // Must be Android
    if (!/Android/i.test(ua)) return false;

    // Android APK WebView indicators
    const hasWV = /\bwv\b/.test(ua); // Chrome WebView
    const oldWebView = /Version\/\d+\.\d+/.test(ua) && !/Chrome/i.test(ua);

    return hasWV || oldWebView;
  }
  const detectEnvironment = () => {
    const ua = navigator.userAgent || "";
    const isIos = /iP(hone|od|ad)/.test(ua);
    const isAndroid = /Android/.test(ua);
    const isStandalone =
      (window.matchMedia &&
        window.matchMedia("(display-mode: standalone)").matches) ||
      window.navigator.standalone === true;
    const inAppPattern =
      /Instagram|FBAN|FBAV|Messenger|Line|WhatsApp|WeChat|MicroMessenger|Twitter|Snapchat|LinkedIn|KAKAOTALK|FB_IAB|FB4A|FB5A/i;
    const isKnownInApp = inAppPattern.test(ua);
    const isiOSWebView = isIos && /AppleWebKit/.test(ua) && !/Safari/.test(ua);
    const isAndroidWebView =
      isAndroid &&
      (/\bwv\b/.test(ua) ||
        /Android.*Version\/\d+\.\d+/.test(ua) ||
        /Version\/\d+\.\d+.*Android/.test(ua));
    const isInApp = Boolean(
      isKnownInApp || isiOSWebView || isAndroidWebView || isStandalone,
    );
    return { isIos, isAndroid, isInApp };
  };

  const handleDownloadQR = async () => {
    const canvas = qrRef.current?.querySelector("canvas");
    if (!canvas) return;

    // Android APK WebView → SHARE ONLY
    const ua = navigator.userAgent || "";
    const isIos = /iP(hone|od|ad)/.test(ua);
    const isAndroid = /Android/.test(ua);

    const isFacebookInApp = /FBAN|FBAV|FB_IAB|FB4A|FB5A/i.test(ua);
    const isAndroidFacebookInApp = isAndroid && isFacebookInApp;
    if (isAndroidFacebookInApp) {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Blob creation failed");
          return;
        }

        const blobUrl = URL.createObjectURL(blob);
        console.log("Opening image URL:", blobUrl);

        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.download = "qr.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        URL.revokeObjectURL(blobUrl);
      }, "image/png");
    }
    if (isAndroidApkInAppWebView()) {
      try {
        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/png"),
        );

        if (!blob) throw new Error("Blob failed");

        const file = new File([blob], "qr.png", { type: "image/png" });

        if (navigator.canShare?.({ files: [file] })) {
          await navigator.share({
            files: [file],
            title: "QR Code",
            text: "Share or save this QR",
          });

          show("Saved to Photos");
          setTimeout(hide, 3000);
          return;
        }
      } catch (e) {
        console.warn("Android share failed", e);
        show("Sharing not supported on this device");
        setTimeout(hide, 3000);
        return;
      }
    }

    // Detect PWA standalone mode
    const isStandalone =
      (window.matchMedia &&
        window.matchMedia("(display-mode: standalone)").matches) ||
      window.navigator.standalone === true;

    // Known in-app / social UAs
    const inAppPattern =
      /Instagram|FBAN|FBAV|Messenger|Line|WhatsApp|WeChat|MicroMessenger|Twitter|Snapchat|LinkedIn|KAKAOTALK|FB_IAB|FB4A|FB5A/i;
    const isKnownInApp = inAppPattern.test(ua);

    // Generic WebView detection:
    // iOS webview often contains "AppleWebKit" but NOT "Safari"
    const isiOSWebView = isIos && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android webview detection: "wv" or "Version/" + Android in UA, or presence of "Android" + "WebView"
    const isAndroidWebView =
      isAndroid &&
      (/\bwv\b/.test(ua) ||
        /Android.*Version\/\d+\.\d+/.test(ua) ||
        /Version\/\d+\.\d+.*Android/.test(ua));

    // Final in-app/webview flag (includes PWA standalone)
    const isInApp = Boolean(
      isKnownInApp || isiOSWebView || isAndroidWebView || isStandalone,
    );

    // Helper: data URL from canvas
    const dataUrl = canvas.toDataURL("image/png");

    // If we're on iOS but NOT in-app (i.e., regular iOS Safari and not standalone),
    // allow the normal download flow so Safari behaves like desktop.
    if (isIos && !isInApp) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `qr.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      return;
    }

    // For in-app browsers / PWA / older iOS where download is blocked:
    // Try navigator.share (modern iOS in-apps & Safari can use it), else open for long-press.
    if (isInApp) {
      try {
        // Convert to blob -> file for navigator.share
        const blob = await (await fetch(dataUrl)).blob();
        const file = new File([blob], `qr.png`, {
          type: "image/png",
        });

        if (navigator.canShare?.({ files: [file] })) {
          await navigator.share({
            files: [file],
            title: "QR Code",
            text: "Save this QR to Photos",
          });
          show("Saved to Photos");
          setTimeout(() => {
            hide();
          }, 4000);
          return;
        }
      } catch (err) {
        // share failed or not supported — we'll fallback to open
        console.warn("share failed or unsupported:", err);
      }
    }
    //  const png = await new Promise((resolve) => {
    //  canvas.toBlob((blob) => {
    //    resolve(blob);
    //  }, "image/png");
    // });
    canvas.toBlob((blob) => {
      if (!blob) {
        console.error("Blob creation failed");
        return;
      }

      const blobUrl = URL.createObjectURL(blob);
      console.log("Opening image URL:", blobUrl);

      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = "qr.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(blobUrl);
    }, "image/png");
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  console.log("timeLeft => ", timeLeft);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-indigo-100 p-4 sm:p-6">
      <div className="flex flex-col md:flex-row-reverse items-center md:items-start gap-8 md:gap-12 w-full max-w-5xl bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-6 sm:p-10 border border-blue-100">
        {/* Right - QR Section */}
        <div className="flex flex-col items-center justify-center w-full md:w-1/2">
          {/* Timer (mobile) */}
          <div className="flex md:hidden items-center gap-2 bg-blue-50 text-blue-700 text-xs sm:text-sm font-medium px-3 sm:px-4 py-1 sm:py-1.5 rounded-full mb-4 shadow-sm">
            <span>⏰</span>
            <span>
              {formatTime(timeLeft)} {MSG[lang].TIMER}
            </span>
          </div>

          {title == "mmqr" && (
            <img
              src="/MMQR_Logo.svg"
              alt="MMQR Logo"
              className="w-auto h-20 sm:h-24 mb-4 sm:mb-3 object-contain"
            />
          )}

          <div className="space-y-2 mb-4 block md:hidden">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 ">
              {MSG[lang].SCAN_TO_PAY}
            </h3>

            {amount && (
              <p className="text-2xl sm:text-3xl font-bold text-blue-600 ">
                {Number(amount).toLocaleString()} MMK
              </p>
            )}
          </div>

          {/* QR Card */}
          <div className="relative p-4 sm:p-6 bg-gradient-to-b from-white to-blue-50 rounded-2xl shadow-lg border border-blue-100">
            <div className="absolute inset-0 rounded-2xl bg-blue-100/10 blur-3xl" />
            <div
              ref={qrRef}
              className="w-[180px] sm:w-[220px] md:w-[250px] lg:w-[280px]"
            >
              <QRCodeCanvas
                value={qrPayload}
                size={256}
                includeMargin
                style={{ width: "100%", height: "auto" }}
                {...(title === "mmqr" && {
                  imageSettings: {
                    src: "/kbzpay.png",
                    height: 48,
                    width: 48,
                    excavate: true,
                  },
                })}
              />
            </div>
          </div>

          {/* Download Button */}
          <button
            onClick={handleDownloadQR}
            className="mt-4 sm:mt-5 px-5 sm:px-6 py-2 sm:py-2.5 bg-blue-600 text-white rounded-lg sm:rounded-xl hover:bg-blue-700 transition font-medium text-xs sm:text-sm shadow-md"
          >
            {MSG[lang].BTN_DOWNLOAD_QR}
          </button>
        </div>

        {/* Left - Info Section */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left gap-4 sm:gap-5 w-full md:w-1/2">
          {/* Timer (desktop) */}
          <div className="hidden md:flex items-center gap-2 bg-blue-50 text-blue-700 text-sm font-medium px-4 py-1.5 rounded-full shadow-sm">
            <span>⏰</span>
            <span>
              {formatTime(timeLeft)} {MSG[lang].TIMER}
            </span>
          </div>

          <div className="hidden md:block space-y-2">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 ">
              {MSG[lang].SCAN_TO_PAY}
            </h3>

            {amount && (
              <p className="text-2xl sm:text-3xl font-bold text-blue-600 ">
                {Number(amount).toLocaleString()} MMK
              </p>
            )}
          </div>

          <p
            className="text-gray-600 text-[14px] w-[230px] sm:w-auto sm:text-[15px] leading-relaxed"
            dangerouslySetInnerHTML={{ __html: MSG[lang].SEND_PAYMENT }}
          />
          <p className="text-gray-700 text-[14px] sm:text-[15px] leading-relaxed break-all">
            {MSG[lang].INVOICE_NUMBER}:{" "}
            <span className="font-medium text-gray-900">
              {merchantOrderId || orderId}
            </span>
          </p>

          {/* How to pay box */}
          <div className="w-full bg-gradient-to-b from-blue-50 to-blue-100 rounded-xl p-4 sm:p-5 mt-2 sm:mt-3 border border-blue-200 shadow-sm">
            <h4 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 sm:mb-3">
              {MSG[lang].HOW_TO_PAY_WITH_SCAN}
            </h4>
            <ol className="list-decimal list-inside text-gray-700 space-y-1 text-[14px] sm:text-[15px]">
              <li>{MSG[lang].STEP1}</li>
              <li>{MSG[lang].STEP2}</li>
              <li>{MSG[lang].STEP3}</li>
            </ol>
          </div>
        </div>
      </div>
      {toast && <NeonToast text={toast} onClose={() => hide()} />}
    </div>
  );
};

export default KPay;
